<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="close" v-on:click="close(false)"/>
      <div class="mediaCnt">
        <div class="mediaPreviewCnt" v-on:click="close(false, 'bg')">
          <div :class="{mediaPreview: true}" v-if="media.file_type === 'video/youtube'">
            <iframe :src="`https://www.youtube.com/embed/${media.file_name}`"
              title="YouTube video player" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media;
              gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <div :class="{mediaPreview: true}" v-else>
            <img class="imagePreview" :src="media.imageLg" v-on:click.stop="doNothing">
          </div>
        </div>
        <div class="mediaInfo">
          <h4>Media Info</h4>
          <div class="infoItem">
            <label>Name</label>
            {{media.title}}
          </div>
          <div class="infoItem">
            <label>Mime Type</label>
            {{media.file_type}}
          </div>
          <div class="infoItem">
            <label>Date Uploaded</label>
            {{media.uploaded_date | moment("ddd, D MMM YYYY hh:mm")}}
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      next: null,
      media: null,
    };
  },
  methods: {
    open(m, n) {
      this.media = m;
      this.next = n;
      this.show = true;
    },
    close(b, type) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    doNothing() {},
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 991;
    display: flex;
    align-items: center;
    justify-content: center;
    // background-color: rgba(255,255,255,.8);
    // backdrop-filter: saturate(180%) blur(20px);
    .close{
      position: absolute;
      right: 10px; top: 5px;
      border-radius: 50%;
      width: 40px; height: 40px;
      background-size: 14px auto;
      background-repeat: no-repeat;
      background-position: center;
      cursor: pointer;

      background-color: #444;
      background-image: url(../assets/close-white.png);

      // background-color: #fff;
      // background-image: url(../assets/close.png);
      &:hover{
        background-color: #222;
        // background-color: #eee;
      }
    }
    .mediaCnt{
      display: flex;
      width: 100%;
      .mediaPreviewCnt{
        height: 100vh;
        width: calc(100% - 300px);
        box-sizing: border-box;
        background-color: #222;
        background-color: rgba(0,0,0,.9);
        position: relative;
        iframe{
          width: 70vw;
          height: 40vw;
        }
        .mediaPreview{
          position: absolute;
          left: 20px; right: 20px; top: 20px; bottom: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          &.video{
            left: 0; right: 0; top: 0;
            // background-color: #000;
          }
          .videoPreview{
            width: 100%;
          }
          .imagePreview{
            max-height: 100%;
            max-width: 100%;
          }
        }
      }
      .mediaInfo{
        width: 300px;
        box-sizing: border-box;
        background-color: #333;
        color: #ddd;
        padding: 20px 30px;
        h4{
          margin: 0 0 20px;
          font-size: 30px;
        }
        .infoItem{
          margin-bottom: 20px;
          font-size: 17px;
          label{
            font-weight: bold;
            text-transform: uppercase;
            color: #767676;
            font-size: 13px;
            display: block;
            margin: 0 0 4px;
          }
          .infoItemX{
            margin-bottom: 6px;
            span{
              float: right;
              font-weight: 600;
              width: 24px;
              text-align: left;
              &.yes{
                color: green;
              }
              &.no{
                color: red;
              }
            }
          }
          .vidThumbCnt{
            display: flex;
            padding-left: 6px;
            .vidThumb{
              width: 60px; height: 60px;
              border-radius: 50%;
              background-size: cover;
              margin-left: -15px;
              border: #333 5px solid;
              box-sizing: border-box;
            }
          }
        }
      }
    }
  }

  .progressCnt{
    background-color: #7b7b7b;
    height: 40px;
    border-radius: 50px;
    overflow: hidden;
    width: 50vw;
    max-width: 600px;
    margin: 0 auto;
    .progress{
      height: 100%;
      background-color: #0bad00;
      color: #fff;
      white-space: nowrap;
      font-weight: bold;
      font-size: 20px;
      text-align: center;
      padding: 6px 20px;
      box-sizing: border-box;
      position: relative;
      transition: all .6s ease;
      span{
        position: relative;
        z-index: 2;
      }
      @-webkit-keyframes MOVE-BG {
        from {
          -webkit-transform: translateX(0);
        }
        to {
          -webkit-transform: translateX(46px);
        }
      }
      @keyframes MOVE-BG {
        from {
          transform: translateX(0);
        }
        to {
          transform: translateX(46px);
        }
      }
      .bg{
        position: absolute;
        left: 0; right: 0; top: 0; bottom: 0;
        overflow: hidden;
        z-index: 1;
      }
      &.processing{
        background-color: orange;
      }
      &.processing .bg:before{
        display: block;
        content: "";
        position: absolute;
        left: -46px;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
        background: -webkit-repeating-linear-gradient(
          145deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        background: repeating-linear-gradient(
          -55deg,
          rgba(0,0,0,.1) 1px,
          rgba(0,0,0,0) 2px,
          rgba(0,0,0,0) 11px,
          rgba(0,0,0,.1) 12px,
          rgba(0,0,0,.1) 20px
        );
        -webkit-animation-name: MOVE-BG;
        -webkit-animation-duration: .6s;
        -webkit-animation-timing-function: linear;
        -webkit-animation-iteration-count: infinite;
        animation-name: MOVE-BG;
        animation-duration: .6s;
        animation-timing-function: linear;
        animation-iteration-count: infinite;
      }
    }
  }
</style>
